@if (isRunning()) {
<av-tooltip position="bottom" align="start" [message]="runningLabel()">
  <div
    class="deepfake-badge"
    data-tid="deepfake/running"
    [attr.data-state]="check()?.state"
  >
    <av-spinner size="xs"></av-spinner>
  </div>
</av-tooltip>
} @if (isVerdict()) {
<av-tooltip position="bottom" align="start" [wrap]="true">
  <div
    class="deepfake-badge"
    [class.deepfake-badge-alert]="status() === 'FAKE'"
    [class.deepfake-badge-warn]="status() === 'SUSPICIOUS'"
    [attr.aria-label]="label() | translate : { reason: labelReason() }"
    [attr.data-partial]="partialLabel() ? 'true' : null"
    data-tid="deepfake/verdict"
  >
    <av-icon size="sm" mode="light" [name]="icon()"></av-icon>
  </div>
  <ng-container tooltipMessage>
    <div class="deepfake-label">
      {{ label() | translate : { reason: labelReason() } }}
    </div>
    @if (hasScore()) {
    <small class="deepfake-score">
      {{ "Synthetic media score" | translate }}: {{ score() }}/100
    </small>
    <small class="deepfake-score-hint" translate>
      A higher score means more likely synthetic
    </small>
    } @for (line of scanLines(); track $index) {
    <div
      class="deepfake-scan-line deepfake-scan-line-{{ line.severity }}"
      [attr.data-tid]="
        'deepfake/scan-' + (line.kind ? line.kind.toLowerCase() : 'details')
      "
    >
      @if (line.kind) {
      <small class="deepfake-scan-verdict">
        <span class="deepfake-scan-kind">{{ line.kind | translate }}:</span>
        {{ line.text | translate }}
        @if (line.detail) {
        <span class="deepfake-detail"> — {{ line.detail }}</span>
        }
      </small>
      } @else if (line.detail) {
      <small class="deepfake-detail">{{ line.detail }}</small>
      } @for (fact of line.facts; track fact.key) {
      <small class="deepfake-fact">{{ fact.key | translate : fact.params }}</small>
      } @for (flag of line.flags; track flag.key) {
      <small class="deepfake-flag">{{ flag.key | translate : flag.params }}</small>
      } @if (line.description) {
      <small class="deepfake-description">
        {{ "Frame" | translate }}: {{ line.description }}
      </small>
      }
    </div>
    }
    <small class="deepfake-disclaimer" translate>
      An automated signal, not proof of identity
    </small>
  </ng-container>
</av-tooltip>
} @if (isUnavailable()) {
<av-tooltip position="bottom" align="start" [wrap]="true">
  <div
    class="deepfake-badge deepfake-badge-muted"
    [attr.aria-label]="unavailableLabel() | translate"
    data-tid="deepfake/unavailable"
  >
    <av-icon size="sm" mode="light" name="info-round"></av-icon>
  </div>
  <ng-container tooltipMessage>
    <div class="deepfake-label">{{ unavailableLabel() | translate }}</div>
    <small class="deepfake-disclaimer" translate>
      This is not a result about the participant
    </small>
  </ng-container>
</av-tooltip>
}
